export default {
  itens(state) {
    return state.itens;
  },
  sheet(state) {
    return state.sheet;
  }
};
